import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from '../ManagerDashboard/Profile.module.css';
import { useNavigate } from 'react-router-dom';

// Message Restriction Modal component
export const MessageRestrictionModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  
  if (!isOpen) return null;
  
  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Messaging Restricted</h2>
        <p>To message this user, one of the following conditions must be met:</p>
        <ul className={styles['modal-list']}>
          <li>You have a Pro or Elite membership</li>
          <li>You are connected with this user</li>
          <li>You are both on the same event for the current month</li>
        </ul>
        <div className={styles['form-actions']}>
          <button 
            className={styles['secondary-button']} 
            onClick={() => navigate('/membership')}
          >
            Upgrade Membership
          </button>
          <button 
            className={styles['primary-button']} 
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export const EmailPermissionModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;
  
  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Email Not Available</h2>
        <p>{message}</p>
        <div className={styles['form-actions']}>
          <button 
            className={styles['primary-button']} 
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};